export default __webpack_public_path__ + "static/media/tab-bottom.151f1fc2.png";